export default __webpack_public_path__ + "static/media/chat.81b9ff99.svg";